<script>
export default {
    name: "login",
    data() {
        return {
            email: '',
            password: '',
            isChecked: false,
            isLoading: false,
        };
    },
    computed: {},
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {
        login() {
            if(this.isLoading){
                return false;
            }
            if(this.email.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.email.focus();
                this.$showToast({ text: 'Please enter email' }); //请输入邮箱
                return false;
            }
            if(!(/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(this.email))){
                this.$refs.email.focus();
                this.$showToast({ text: 'Incorrect email format' }); //邮箱格式有误
                return false;
            }
            if(this.password.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.password.focus();
                this.$showToast({ text: 'Please enter password' }); //请输入密码
                return false;
            }
            this.isLoading = true;
            this.$store.dispatch('login', {
                email: this.email,
                password: this.password
            }).then((result) => {
                this.isLoading = false;
                if(result.code == 100){
                    localStorage.setItem('token', result.data.token);
                    this.$store.state.isLogin = true;
                    this.$store.state.userinfo = result.data.userinfo;
                    if(this.$route.query.redirect){
                        this.$router.replace(this.$route.query.redirect);
                    }else{
                        this.$router.replace('/mine');
                    }
                }
                else if(result.code == 101){
                    this.$showToast({ text: 'The account does not exist or the password is incorrect' }); //账号不存在或密码错误
                }
            }).catch((err) => {
                this.isLoading = false;
            });
        }
    },
};
</script>

<template>
    <div class="login layout_main flex flex_column justify_center">
        <p class="title">Login to Your Account</p>
        <div class="input_group">
            <input type="email" placeholder="Email Address" name="email" ref="email" v-model="email" />
            <input :type="isChecked ? 'text' : 'password'" placeholder="Password" name="password" ref="password" v-model="password"/>
            <div class="check flex align_center" @click="isChecked = !isChecked">
                <div class="checkbox" :class="{active: isChecked}"></div>
                <p>Show Password</p>
            </div>
        </div>
        <div class="flex justify_end">
            <p class="forgot">Forgot Your Password?</p>
        </div>
        <div class="btn flex_center" @click="login">Login</div>
    </div>
</template>

<style scoped lang="scss">
.login{
    width: 4.8rem;
    padding: 1rem 0;
    flex: 1;
    @media only screen and (max-width: 750px) {
        width: 6.9rem;
    }
    .title{
        font-size: .4rem;
        font-weight: bold;
        margin-bottom: .4rem;
        text-align: center;
    }
    .input_group{
        margin-bottom: .5rem;
    }
    input{
        width: 100%;
        height: .5rem;
        margin-bottom: .2rem;
        border: 1px solid #999;
        border-radius: .03rem;
        padding: 0 .25rem;
        font-size: .16rem;
        &::placeholder{
            color: #999;
        }
    }
    .check{
        font-size: .12rem;
        color: #999;
        cursor: pointer;
        user-select: none;
    }
    .checkbox{
        width: .14rem;
        height: .14rem;
        border: 1px solid #999;
        margin-right: .1rem;
        margin-bottom: 0;
        padding: 0;
        border-radius: 0;
        position: relative;
        &.active{
            &::after{
                content: "";
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 50%;
                height: 50%;
                background: var(--background-color);
            }
        }
    }
    .forgot{
        font-size: .12rem;
        color: #cc3333;
        margin-bottom: .15rem;
        cursor: pointer;
    }
    .btn{
        width: 100%;
        height: .5rem;
        font-size: .24rem;
        font-weight: bold;
        color: var(--color-blue);
        background: var(--background-color);
        border-radius: .5rem;
        cursor: pointer;
    }
}
</style>